import { useFilterEmployeeShiftContext } from "./filter-employee-shift.context";

export function FilterEmployeeShift() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterEmployeeShiftContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}